module.exports = __webpack_public_path__ + "static/img/inviteHeader.3a3927f4.png";